export enum FairValueChartTabs {
  COMPANY = 'Company',
  FUND = 'Fund',
  INDUSTRY = 'Industry',
  COUNTRY = 'Country',
  GROUP = 'Group',
  ASSETS = 'Assets',
}

export enum IrFairValueChartTabs {
  COMPANY = 'Company',
  INDUSTRY = 'Industry',
  COUNTRY = 'Country',
  GROUP = 'Group',
  ASSETS = 'Assets',
  NO_TAB = 'No tab'
}

export enum PpChartsMenuValues {
  fmv = 'fmv',
  investment = 'investment',
}
